<template>
  <div id="app">
    <topVue v-if="$route.meta.isQuan!=true" />
    <headerVue v-if="$route.meta.isHeader" />
    <router-view v-wechat-title="$route.meta.title" />
    <footerVue v-if="$route.meta.isQuan!=true" />

    <!--登录组件-->
    <LoginVue />
  </div>
</template>

<script>
import topVue from "@/components/top.vue"
import headerVue from "@/components/header.vue";
import footerVue from "@/components/footer.vue";
export default {
  components:{
    headerVue,footerVue,topVue
  },
  name: 'App',
  data(){
    return{

    }
  },
  mounted(){
    console.log(this.$route);
  },
}
</script>

<style lang="scss">
body,html{
  margin: 0;
  padding:0;
}
.content{
  width: 100%;
  height: 100%;
  position: relative;
  // background: #eee !important;
}
.has-gutter .cell{
  font-size: 18px!important;
}
.el-table__row .cell{
  font-size: 16px!important;
}
.two{
  overflow: hidden;
		-webkit-line-clamp: 2;
		text-overflow: ellipsis;
		display: -webkit-box!important;
		-webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/App.vue